module.exports = __webpack_public_path__ + "img/forgetpasswordimage.571f200f.png";